module.exports = __webpack_public_path__ + "img/qy_2.9595544b.png";